"use client";

import type { CSSProperties } from "react";
import { MACARON } from "./tokens";

export const MACARON_CARD_SURFACE_CLASSNAME = "md:w-fit md:min-w-[360px] md:max-w-full overflow-hidden rounded-2xl px-5 py-4";

export function getMacaronCardSurfaceStyle(): CSSProperties {
  return {
    // The translucent fill + soft shadow already separate these cards from the chat background.
    // Keeping a border on top of that made structured canvas cards look double-framed in practice.
    backgroundColor: MACARON.cardBg,
    boxShadow: MACARON.cardShadow,
    backdropFilter: "blur(12px)",
  };
}
